export default __webpack_public_path__ + "static/media/NotoSansSCBold-subset.d7f89adf.woff2";